import { useMemo } from 'react';
import { useAuthStore } from '@/stores/AuthStore';
import { PatientDTO } from '@/data/DTOs/schedule/PatientDTO';
import { handleRequestError, useRestClient } from '../useRestClient';
import { USER_DEPENDENTS_LIST_URL } from '@/constants/constants';

export function usePatientService() {
  const { restClient } = useRestClient();
  const { user } = useAuthStore();

  const getPatientsList = async (): Promise<PatientDTO[]> => {
    try {
      const loggedUserDTO: PatientDTO = {
        id: user?.id ?? '',
        name: user?.name ?? '',
        surname: user?.surname ?? '',
        birthDate: user?.birthdate ?? '',
        profilePhotoUrl: user?.picture,
        userDependentId: undefined,
      };

      const response = await restClient.get(`${USER_DEPENDENTS_LIST_URL}`);

      const patientList = response.data as PatientDTO[];

      patientList.unshift(loggedUserDTO);

      return patientList;
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  return useMemo(
    () => ({
      getPatientsList,
    }),
    []
  );
}
